import { HTTPStatuses } from '@packages/domain/constants/http';
import {
  FETCH_USER_FAILURE,
  FETCH_USER_PAYMENTS_FAILURE,
} from 'constants/index';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';

const isUnauthorized = ({ status = '' }) =>
  status === HTTPStatuses.UNAUTHORIZED;

const isReportable = (actionType: any) => {
  switch (actionType) {
    case FETCH_USER_PAYMENTS_FAILURE:
    case FETCH_USER_FAILURE:
      return true;
    default:
      return false;
  }
};

const ErrorLogger = (_store: any) => (next: any) => (action: any) => {
  const { type, payload = {} } = action;
  const shouldNotifyError = isReportable(type) && !isUnauthorized(payload);

  if (shouldNotifyError) {
    errorNotifier.notifyWithFingerprint(payload, [type, payload.message]);
  }

  return next(action);
};

export { ErrorLogger };
